import { useState, type ReactNode } from 'react';
import { Dropdown, Modal } from 'antd';
import type { MenuProps } from 'antd';

interface Props {
  hasPhoto: boolean;
  onView: () => void;
  onChangePhoto: () => void;
  onRemove: () => void;
  children: ReactNode;
}

/** WhatsApp-style avatar menu: View / Change / Remove (remove is confirm-gated). */
export default function ProfilePhotoMenu({ hasPhoto, onView, onChangePhoto, onRemove, children }: Props) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const items: MenuProps['items'] = [
    ...(hasPhoto ? [{ key: 'view', label: 'View photo' }] : []),
    { key: 'change', label: hasPhoto ? 'Change photo' : 'Upload photo' },
    ...(hasPhoto ? [{ key: 'remove', label: 'Remove photo', danger: true as const }] : []),
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'view') onView();
    else if (key === 'change') onChangePhoto();
    else if (key === 'remove') setConfirmOpen(true);
  };

  return (
    <>
      <Dropdown menu={{ items, onClick }} trigger={['click']} placement="bottomLeft">
        {children}
      </Dropdown>
      <Modal
        open={confirmOpen}
        title="Remove profile photo?"
        okText="Remove"
        okButtonProps={{ danger: true }}
        cancelText="Cancel"
        width={380}
        centered
        onOk={() => { setConfirmOpen(false); onRemove(); }}
        onCancel={() => setConfirmOpen(false)}
      >
        Your initials will be shown instead.
      </Modal>
    </>
  );
}
